module.exports = __webpack_public_path__ + "static/media/melissa10.78b06abe.jpg";